import React from 'react';
import MadlanLogoIcon from 'assets/svg/il-logo.svg';
import { Subtitle, Title, WelcomeButton, Wrapper } from './styled';
import { useLocale } from 'locale';
import { connect } from 'react-redux';
import { setInvestorsLoginStep } from 'store/state/app/actions';
import { AuthenticationModalType } from 'components/authentication/types';
import { Dispatch } from 'redux';
import { RootAction } from 'store/state';

interface WelcomeLoginProps {
  onWelcomeSubmit: () => void;
}

// connected users without accepted investors terms never see this step — LoginPage derives the
// terms step for them directly, so Welcome always leads to the sign-up flow
const WelcomeLoginBase: React.FC<WelcomeLoginProps> = ({ onWelcomeSubmit }) => {
  const { t } = useLocale();

  return (
    <Wrapper>
      <MadlanLogoIcon width={150} height={30} />
      <Title>{t('investors.login.welcome.title')}</Title>
      <Subtitle>{t('investors.login.welcome.subtitle')}</Subtitle>
      <WelcomeButton fullWidth size="extraLarge" data-auto="welcome-login-button" onClick={() => onWelcomeSubmit()}>{t('investors.login.welcome.button')}</WelcomeButton>
    </Wrapper>
  );
};

const mapDispatchToProps = (dispatch: Dispatch<RootAction>) => ({
  onWelcomeSubmit: () => dispatch(setInvestorsLoginStep({ type: AuthenticationModalType.SignUp }, { isUserInitiated: true })),
});

export const WelcomeLogin = connect(null, mapDispatchToProps)(WelcomeLoginBase);
